var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16796_14528)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16796_14528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8537 0.145173C15.9229 0.214505 15.9702 0.302647 15.9898 0.398651C16.0094 0.494654 16.0003 0.594287 15.9637 0.685173L10.1447 15.2322C10.0934 15.3603 10.0078 15.4718 9.89722 15.5543C9.78666 15.6369 9.65547 15.6874 9.51807 15.7002C9.38068 15.713 9.24241 15.6877 9.11848 15.627C8.99456 15.5663 8.88978 15.4726 8.81569 15.3562L5.63769 10.3612L0.642687 7.18317C0.526005 7.10916 0.432039 7.00434 0.371157 6.8803C0.310276 6.75626 0.284845 6.61781 0.297672 6.48023C0.3105 6.34264 0.361086 6.21128 0.443848 6.10063C0.526611 5.98998 0.638334 5.90434 0.766688 5.85317L15.3137 0.0361732C15.4046 -0.000414535 15.5042 -0.00949426 15.6002 0.0100619C15.6962 0.0296181 15.7844 0.0769483 15.8537 0.146173V0.145173ZM6.63569 10.0692L9.39669 14.4072L14.1297 2.57517L6.63569 10.0692ZM13.4227 1.86817L1.59069 6.60117L5.92969 9.36117L13.4237 1.86817H13.4227Z",
    fill: "#4B99F7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16796_14528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16796_14528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.9f6c61c5c963ecc0adac9f562db331a6.svg";
export { ForwardRef as ReactComponent };